export default __webpack_public_path__ + "static/media/ceu-limpo.266b8015.svg";